import React, { FunctionComponent, ReactElement } from 'react';

import { Box, Typography } from '@mui/material';

import StatisticsChart from './statistics-chart/statistics-chart';
import StatisticsFilter from './statistics-filters/components/statistics-filter';
import { StatisticsTable } from './statistics-table/statistics-table';

export const Statistics: FunctionComponent = (): ReactElement => {
  return (
    <Box data-testid="statistics">
      <StatisticsFilter />
      <StatisticsChart />
      <Typography variant="h5" sx={{ fontWeight: 300, my: '24px' }}>
        Table View
      </Typography>
      <StatisticsTable />
    </Box>
  );
};
